import React from "react";
import  "./Navbar.css";
import { Link, useLocation } from "react-router-dom";
import logo from "../../assets/logo-svg.png"
import { useDispatch, useSelector } from "react-redux";
import { changeLocal } from "../../hooks/Localization";
export default function Navbar() {
  const dispatch = useDispatch();
  // const { locale } = router;
  const location = useLocation();
  const asPath=location?.pathname;
  console.log(location?.pathname);
  
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const handleLang = () => {
    dispatch(
      changeLocal(
        currentLocal && currentLocal.language === "English" ? "ar" : "en"
      )
    );
  }  // const t = useTranslations("general");
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white fixed-top">
      <div className="container-fluid">
        <Link to="/">
          <img
            src={logo}
            alt="logo"
            style={{ width: "200px", cursor: "poiter" }}
          />
        </Link>{" "}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent" style={{zIndex:"500000"}}>
          <ul
            className={
              currentLocal.language == "English"
                ? "navbar-nav me-auto mb-2 mb-lg-0 "
                : "navbar-nav ms-auto mb-2 mb-lg-0 "
            }
            
          >
            <li  className={asPath=="/"?"nav-item active":"nav-item "}>
              <Link to="/">{currentLocal.general.home}</Link>
            </li>
            <li  className={asPath=="/aboutus"?"nav-item active":"nav-item "}>
              <Link to="/aboutus">{currentLocal.general.about}</Link>
            </li>
            <li   className={asPath=="/services"?"nav-item active":"nav-item "}>
              <Link to="/services">{currentLocal.general.services}</Link>

            </li>
                  <li   className={asPath=="/portfolio"?"nav-item active":"nav-item "}>
              <Link to="/portfolio">{currentLocal.general.portfolio}</Link>

            </li>
            <li   className={asPath=="/contact-us"?"nav-item active":"nav-item "}>
              <Link to="/contact-us">{currentLocal.general.contact}</Link>
            </li>
          </ul>
          <form className="d-flex">
            <p className="lang">
              {currentLocal.language == "العربيه" ? (
                <div
                  className="langLinks"
                  color="initial"
onClick={handleLang}
                >
                  English
                </div>
              ) : (
                <div
                  color="initial"
                  // locale={"ar"}
onClick={handleLang}
                  className="arLangLinks"
                >
                  العربية
                </div>
              )}
            </p>
          </form>
        </div>
      </div>
    </nav>
  );
}
